<!--
* @Author : ShaJiaJing
* @Date :  2019/6/5
* @Version : 1.0
* @Content : 消息列表页
-->
<template>
  <div class="message">
    <r-pointer :textName="`${ $t('private.message.title') }`" />
    <!-- 搜索 -->
    <r-search class="p_search" @on-search="commSearch" @on-blur="changeContent">
      <div slot="senior">
        <a-form layout="inline" @submit="handleSearch">
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-item v-bind="formItemLayout" :label="$t('private.message.level')">
                <a-select v-model="conditions.alertLevel">
                  <a-select-option v-for="(item, index) in levelOptions" :key="index" :value="item.value"> {{ item.label }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item v-bind="formItemLayout" :label="$t('private.message.module')">
                <a-input :placeholder="$t('private.common.input')" v-model="conditions.alertModule"/>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item v-bind="formItemLayout" :label="$t('private.message.status')">
                <a-select v-model="conditions.alertStatus">
                  <a-select-option v-for="(item, index) in statusOptions" :key="index" :value="item.value"> {{ item.label }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item v-bind="formItemLayout" :label="$t('private.message.date')">
                <a-range-picker style="width: 100%" v-model="conditionDate" @change="selectRangeDate"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24" class="btn_gruop">
              <a-button type="primary" html-type="submit" > {{ $tc('private.actions.search', 0) }} </a-button>
              <a-button :style="{ marginLeft: '8px' }" @click="resetConditions" >
                {{ $tc('private.actions.clear') }}
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </r-search>
    <!-- 列表数据 -->
    <a-table
      rowKey="id"
      :rowSelection="rowSelection"
      :loading="result.loading"
      :columns="columns"
      :dataSource="result.data"
      :pagination="pagination"
    >
      <span :class="`level-${alertLevel} ellipsis`" slot="level" slot-scope="alertLevel">
        <span :class="['dot', alertLevel]"></span>
        <span>{{ alertLevel }}</span>
      </span>
      <div class="action" slot="operation" slot-scope="record">
        <span v-if="record.alertStatus === 'new'" @click="editMessage([record.id])">
          {{ $t('private.actions.confirm') }}
        </span>
        <span @click="delMessage([record.id])">
          {{ $tc('private.actions.delete', 1) }}
        </span>
      </div>
      <div class="all-actions" slot="footer" slot-scope="text">
        <span v-if="false">{{ text }}</span>
        <a-button :disabled="!confirmAll" type="primary" @click="editMessage(selectedRowKeys)">
          {{ $t('private.actions.confirm') }}
        </a-button>
        <a-button :disabled="!selectedRowKeys.length" type="primary" @click="delMessage(selectedRowKeys)">
          {{ $tc('private.actions.delete', 1) }}
        </a-button>
      </div>
    </a-table>
  </div>
</template>

<script>
import { getMessageList, editMessageList, delMessage } from '@api/message'
import { mixinPagination } from '@/utils/mixin'
const defaultConditions = {
  alertStatus: '',
  searchContent: '',
  queryStartDate: '',
  queryEndDate: '',
  alertModule: '',
  alertLevel: ''
}
export default {
  data () {
    return {
      formItemLayout: {
        labelCol: {
          span: 6
        },
        wrapperCol: {
          span: 18
          // xl: {
          //   span: 18
          // }
        }
      },
      conditionDate: [],
      dateOptions: [
        {
          value: 1,
          label: '今天'
        },
        {
          value: 2,
          label: '昨天'
        },
        {
          value: 3,
          label: '最近7天'
        },
        {
          value: 4,
          label: '最近30天'
        }
      ],
      statusOptions: [
        {
          value: '',
          label: this.$t('private.message.statuss.all')
        },
        {
          value: 'new',
          label: this.$t('private.message.statuss.new')
        },
        {
          value: 'confirmed',
          label: this.$t('private.message.statuss.confirmed')
        }
      ],
      levelOptions: [
        {
          value: '',
          label: this.$t('private.message.levels.all')
        },
        {
          value: 'info',
          label: this.$t('private.message.levels.info')
        },
        {
          value: 'warn',
          label: this.$t('private.message.levels.warn')
        },
        {
          value: 'error',
          label: this.$t('private.message.levels.error')
        },
        {
          value: 'fatal',
          label: this.$t('private.message.levels.fatal')
        }
      ],
      conditions: JSON.parse(JSON.stringify(defaultConditions)),
      result: {
        loading: false,
        data: []
      },
      // 统计数据
      countData: {},
      form: this.$form.createForm(this),
      selectedRowKeys: [],
      confirmAll: false,
      columns: [
        {
          title: this.$t('private.message.time'),
          dataIndex: 'alertTime',
          width: 160,
          scopedSlots: { customRender: 'time' }
        },
        {
          title: this.$t('private.message.level'),
          dataIndex: 'alertLevel',
          // width: 180,
          scopedSlots: { customRender: 'level' }
        },
        {
          title: this.$t('private.message.module'),
          dataIndex: 'alertModule',
          // width: 220,
          customCell: (record, index) => {
            return {
              style: {
                whiteSpace: 'nowrap'
              }
            }
          }
        },
        {
          title: this.$t('private.message.content'),
          dataIndex: 'alertDesc',
          customCell: (record, index) => {
            return {
              style: {
                wordBreak: 'break-all'
              }
            }
          }
        },
        {
          title: this.$t('private.common.operation'),
          key: 'operation',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'operation' }
        }
      ]
    }
  },
  mixins: [mixinPagination],
  computed: {
    rowSelection () {
      const { selectedRowKeys } = this
      return {
        selectedRowKeys,
        onChange: (keys, selectedRows) => {
          this.$set(this, 'confirmAll', selectedRows.some(row => row.alertStatus === 'new'))
          this.$set(this, 'selectedRowKeys', keys)
        }
      }
    }
  },
  created () {
    this.getList()
  },
  methods: {
    editMessage (ids) {
      ids = ids.join(',')
      editMessageList({ ids, alertStatus: 'confirmed' }).then(res => {
        this.$message.success(this.$t('custom.tip.confirmSuccess'))
        this.getList()
      })
    },
    changePage (current) {
      Object.assign(this.pagination, { current })
      this.getList()
    },
    delMessage (ids) {
      this.$confirm({
        title: this.$t('custom.tip.deleteTitle'),
        content: '',
        onOk: () => {
          delMessage(ids).then(res => {
            this.$message.success(this.$t('custom.tip.deleteSuccess'))
            this.getList()
          })
        },
        onCancel: () => {
          this.$message.success(this.$t('custom.tip.cancelled'))
        }
      })
    },
    getList () {
      Object.assign(this.result, { loading: true })
      const { current: page, pageSize: size } = this.pagination
      getMessageList(Object.assign(this.conditions, { page, size })).then(({ total, items }) => {
        Object.assign(this.result, { data: items, loading: false })
        Object.assign(this.pagination, { total })
      })
    },
    handleSearch  (e) {
      e.preventDefault()
      Object.assign(this.pagination, { current: 1 })
      this.getList()
    },
    changeContent (val) {
      Object.assign(this.conditions, {
        searchContent: val
      })
    },
    /**
     * 普通搜索
     */
    commSearch (val) {
      this.conditions = Object.assign(JSON.parse(JSON.stringify(defaultConditions)), { searchContent: val })
      Object.assign(this.pagination, { current: 1 })
      this.getList()
    },
    /**
     * 创建时间
     */
    selectRangeDate (date, dateArr) {
      Object.assign(this.conditions, {
        queryStartDate: dateArr[0],
        queryEndDate: dateArr[1]
      })
    },
    /**
     * 高级搜索表单清空
     */
    resetConditions () {
      this.conditionDate = []
      this.conditions = JSON.parse(JSON.stringify(defaultConditions))
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@assets/styles/base/color.less";
/*#1890ff*/
/*#40a9ff*/
/*transition: color 0.3s;*/
.dot{
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  &.info{
    background-color: @info;
  }
  &.warn{
    background-color: @warn;
  }
  &.error{
    background-color: @error;
  }
  &.fatal{
    background-color: @fatal;
  }
}
.level-info{
  color: @info;
}
.level-warn{
  color: @warn;
}
.level-error{
  color: @error;
}
.level-fatal{
  color: @fatal;
}
.action{
  span{
    color: #1890ff;
    cursor: pointer;
    transition: color 0.3s;
    /*position: relative;*/
    &:hover{
      color: #40a9ff;
    }
    & + span{
      &:before{
        content: '';
        display: inline-block;
        height: 12px;
        width: 1px;
        background-color: #e8e8e8;
        margin: 0 8px -1px;
      }
    }
  }
}
.all-actions{
  .ant-btn{
    margin-right: 20px;
  }
}
.message {
  padding: 0 24px 12px 12px;
  background: #fff;
  .p_search {
    margin: 9px 0;
  }
  .btn_gruop {
    margin: 20px 0 10px 70px;
    button {
      margin-right: 10px;
    }
  }
}
.ant-row {
  margin-top: 5px;
  width: 100%;
}
</style>
